import type { StatusDelivery, StatusMotoboy } from './Interfaces/Data';
import { version as VERSION } from '../package.json';

export { VERSION };

export const MediaQueryMobile = '(max-width: 768px)';
export const MediaQueryTablet = '(max-width: 1080px)';
export const MediaQueryComputer = '(min-width: 769px)';

export const DEFAULT_LIMIT_REQUEST = 30;

export const MOTOBOY_STATUS: Record<StatusMotoboy, StatusMotoboy> = {
  OFFLINE: 'OFFLINE',
  PRECADASTRO: 'PRECADASTRO',
  BLOQUEADO: 'BLOQUEADO',
  EM_CORRIDA: 'EM_CORRIDA',
  ENTREGA_ASSOCIADA: 'ENTREGA_ASSOCIADA',
  DISPONIVEL: 'DISPONIVEL',
  REPROVADO: 'REPROVADO',
  EXCLUIDO: 'EXCLUIDO',
};

export const REGEX_LATITUDE =
  /^(\+|-)?(?:90(?:(?:\.0{1,8})?)|(?:[0-9]|[1-8][0-9])(?:(?:\.[0-9]{1,8})?))$/;

export const REGEX_LONGITUDE =
  /^(\+|-)?(?:180(?:(?:\.0{1,8})?)|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:\.[0-9]{1,8})?))$/;

export const STATUS_ENTREGA: Record<StatusDelivery, StatusDelivery> = {
  PENDENTE: 'PENDENTE',
  ASSOCIADO: 'ASSOCIADO',
  ACEITO: 'ACEITO',
  CHEGOU_NA_LOJA: 'CHEGOU_NA_LOJA',
  CANCELADO: 'CANCELADO',
  SAIU_DA_LOJA: 'SAIU_DA_LOJA',
  CHEGOU_NO_CLIENTE: 'CHEGOU_NO_CLIENTE',
  PERSONALIZAR_CORRIDA: 'PERSONALIZAR_CORRIDA',
  ENTREGUE: 'ENTREGUE',
  FINALIZADO: 'FINALIZADO',
};

export const STATUS_ENTREGA_NORMALIZED: Record<StatusDelivery, string> = {
  PENDENTE: 'Pendente',
  ASSOCIADO: 'Associado',
  ACEITO: 'Aceito',
  CHEGOU_NA_LOJA: 'Chegou na loja',
  CANCELADO: 'Cancelado',
  SAIU_DA_LOJA: 'Saiu da loja',
  CHEGOU_NO_CLIENTE: 'Chegou no cliente',
  PERSONALIZAR_CORRIDA: 'Personalizar corrida',
  ENTREGUE: 'Entregue',
  FINALIZADO: 'Finalizado',
};
